import { render } from "./leads-list.vue?vue&type=template&id=5a3092ba&scoped=true"
import script from "./leads-list.vue?vue&type=script&lang=js"
export * from "./leads-list.vue?vue&type=script&lang=js"

import "./leads-list.vue?vue&type=style&index=0&id=5a3092ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3092ba"]])

export default __exports__